// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__A9CC4","icon":"SortAdornment_icon__17ca3","up":"SortAdornment_up__mXF1Z","down":"SortAdornment_down__19pDN","active":"SortAdornment_active__aR-3o"};